module.exports = __webpack_public_path__ + "assets/img/title.599fdb1b.png";